import React, { useState, useMemo } from "react"
import Select, { components } from "react-select"
import vars from "../styles/vars"
import { useStaticQuery, graphql } from "gatsby"

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    background: "transparent",
    margin: 0,
    boxShadow: "none",
    border: "1px solid" + vars.colors.gray + " !important",
    borderRadius: "0 0 4px 4px",
  }),
  menuList: (provided, state) => ({
    ...provided,
    padding: 0,
  }),
  container: provided => ({
    ...provided,
    fontSize: "12px",
  }),
  control: (provided, state) => ({
    ...provided,
    background: "transparent",
    borderColor: vars.colors.gray + " !important",
    borderRadius: "4px 4px 0 0 ",
    boxShadow: "none",
    margin: 0,
    minHeight: "32px",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: vars.colors.gray,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    width: "90px",
  }),
  indicatorSeparator: (provided, state) => ({
    display: "none",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: vars.colors.gray + " !important",
    padding: "3px 8px",
  }),
  option: (provided, state) => {
    return {
      ...provided,
      background:
        (state.isSelected
          ? "#fff"
          : state.isFocused
          ? vars.colors.gray
          : "transparent") + " !important",
      color:
        state.isFocused || state.isSelected
          ? vars.colors.grayDark
          : vars.colors.gray,
    }
  },
}

const customComponents = {
  DropdownIndicator: props => {
    return (
      <components.DropdownIndicator {...props}>
        <svg
          height={15 * 0.5}
          width={20 * 0.5}
          viewBox="0 0 20 15"
          aria-hidden="true"
          focusable="false"
          fill={vars.colors.gray}
        >
          <polygon points="0,0 20,0 10,15" />
        </svg>
      </components.DropdownIndicator>
    )
  },
}

const History = () => {
  const optionsFromQuery = useStaticQuery(graphql`
    query {
      dataJson(name: { eq: "goals" }) {
        history {
          value
          url
          label
        }
      }
    }
  `).dataJson.history.sort((a, b) => b.value - a.value)

  const defaultOption = useMemo(
    () =>
      optionsFromQuery.reduce((currentOption, option) => {
        if (currentOption == null) return option
        if (option.value > currentOption.value) return option
        return currentOption
      }, null),
    [optionsFromQuery]
  )
  const [selectedOption, setSelectedOption] = useState(defaultOption)

  const onChange = option => {
    console.log("TODO: change url to: " + option.url)
    setSelectedOption(option)
  }

  return (
    <Select
      defaultValue={selectedOption}
      onChange={onChange}
      options={optionsFromQuery}
      styles={customStyles}
      components={customComponents}
      isSearchable={false}
    />
  )
}

export default History
